export default __webpack_public_path__ + "static/media/cd.efc6364d.svg";